module.exports = __webpack_public_path__ + "21_pvis.jpg?6abb9a27152d3487191e80af112babce";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/21_pvis.jpg
// module id = 177
// module chunks = 0